/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-sql-groupby-having-visualizer-fr block)");
/* eslint-enable no-console */


(function () {
    const datasets = {

        ventes: {
            tableName: "ventes", groupCol: "categorie",
            aggCols: [{ fn: "SUM", col: "montant", label: "sum_montant" }],
            hint: "Table <code>ventes</code> — GROUP BY categorie",
            rows: [
                { id: 1, categorie: "Livres", montant: 25 },
                { id: 2, categorie: "Électronique", montant: 120 },
                { id: 3, categorie: "Livres", montant: 15 },
                { id: 4, categorie: "Vêtements", montant: 60 },
                { id: 5, categorie: "Électronique", montant: 200 },
                { id: 6, categorie: "Livres", montant: 35 },
                { id: 7, categorie: "Vêtements", montant: 45 },
                { id: 8, categorie: "Électronique", montant: 80 }
            ]
        },

        employes: {
            tableName: "employes", groupCol: "departement",
            aggCols: [{ fn: "AVG", col: "salaire", label: "avg_salaire" }],
            hint: "Table <code>employes</code> — GROUP BY departement",
            rows: [
                { id: 1, nom: "Emma", departement: "Dev", salaire: 3800 },
                { id: 2, nom: "Liam", departement: "Marketing", salaire: 3200 },
                { id: 3, nom: "Noah", departement: "Dev", salaire: 4100 },
                { id: 4, nom: "Olivia", departement: "RH", salaire: 2900 },
                { id: 5, nom: "Ethan", departement: "Marketing", salaire: 3500 },
                { id: 6, nom: "Ava", departement: "Dev", salaire: 4400 },
                { id: 7, nom: "Lucas", departement: "RH", salaire: 3100 }
            ]
        },

        commandes_client: {
            tableName: "commandes", groupCol: "client",
            aggCols: [{ fn: "COUNT", col: "*", label: "total_commandes" }],
            hint: "Table <code>commandes</code> — GROUP BY client",
            rows: [
                { id: 1, client: "Alice", produit: "Stylo", total: 12 },
                { id: 2, client: "Bob", produit: "Cahier", total: 8 },
                { id: 3, client: "Alice", produit: "Règle", total: 5 },
                { id: 4, client: "Charlie", produit: "Crayon", total: 3 },
                { id: 5, client: "Bob", produit: "Stylo", total: 12 },
                { id: 6, client: "Alice", produit: "Gomme", total: 2 },
                { id: 7, client: "Charlie", produit: "Cahier", total: 8 }
            ]
        },

        clients_ville: {
            tableName: "clients", groupCol: "ville",
            aggCols: [{ fn: "AVG", col: "age", label: "age_moyen" }],
            hint: "Table <code>clients</code> — GROUP BY ville",
            sqlOverride: "SELECT ville,\n       AVG(age) AS age_moyen\nFROM clients\nGROUP BY ville;",
            rows: [
                { id: 1, nom: "Alice", ville: "Paris", age: 28 },
                { id: 2, nom: "Bob", ville: "Lyon", age: 34 },
                { id: 3, nom: "Claire", ville: "Paris", age: 22 },
                { id: 4, nom: "David", ville: "Marseille", age: 41 },
                { id: 5, nom: "Emma", ville: "Lyon", age: 29 },
                { id: 6, nom: "Farid", ville: "Paris", age: 36 },
                { id: 7, nom: "Gaëlle", ville: "Marseille", age: 25 },
                { id: 8, nom: "Hugo", ville: "Lyon", age: 31 }
            ]
        },

        commandes_statut: {
            tableName: "commandes", groupCol: "statut",
            aggCols: [{ fn: "COUNT", col: "*", label: "total_commandes" }],
            hint: "Table <code>commandes</code> — GROUP BY statut",
            sqlOverride: "SELECT statut,\n       COUNT(*) AS total_commandes\nFROM commandes\nGROUP BY statut;",
            rows: [
                { id: 1, client: "Alice", statut: "Livré", montant: 45 },
                { id: 2, client: "Bob", statut: "En cours", montant: 120 },
                { id: 3, client: "Claire", statut: "Livré", montant: 30 },
                { id: 4, client: "David", statut: "Annulé", montant: 80 },
                { id: 5, client: "Emma", statut: "En cours", montant: 60 },
                { id: 6, client: "Farid", statut: "Livré", montant: 15 },
                { id: 7, client: "Gaëlle", statut: "Annulé", montant: 200 },
                { id: 8, client: "Hugo", statut: "En cours", montant: 55 },
                { id: 9, client: "Inès", statut: "Livré", montant: 90 },
                { id: 10, client: "Jules", statut: "Livré", montant: 35 }
            ]
        },

        ventes_ca: {
            tableName: "ventes", groupCol: "categorie",
            aggCols: [{ fn: "SUM_EXPR", col: "ca", label: "chiffre_affaires", expr: r => r.prix * r.quantite }],
            hint: "Table <code>ventes</code> — GROUP BY categorie — SUM(prix × quantite)",
            sqlOverride: "SELECT categorie,\n       SUM(prix * quantite) AS chiffre_affaires\nFROM ventes\nGROUP BY categorie;",
            rows: [
                { id: 1, categorie: "Électronique", produit: "Téléphone", prix: 299, quantite: 3 },
                { id: 2, categorie: "Vêtements", produit: "T-shirt", prix: 25, quantite: 10 },
                { id: 3, categorie: "Électronique", produit: "Casque", prix: 89, quantite: 5 },
                { id: 4, categorie: "Livres", produit: "Roman", prix: 12, quantite: 8 },
                { id: 5, categorie: "Vêtements", produit: "Jean", prix: 60, quantite: 4 },
                { id: 6, categorie: "Livres", produit: "BD", prix: 18, quantite: 6 },
                { id: 7, categorie: "Électronique", produit: "Tablette", prix: 349, quantite: 2 },
                { id: 8, categorie: "Vêtements", produit: "Veste", prix: 90, quantite: 3 }
            ]
        },

        produits_fournisseur: {
            tableName: "produits", groupCol: "fournisseur",
            aggCols: [
                { fn: "MIN", col: "prix", label: "prix_min" },
                { fn: "MAX", col: "prix", label: "prix_max" }
            ],
            hint: "Table <code>produits</code> — GROUP BY fournisseur — MIN et MAX simultanés",
            sqlOverride: "SELECT fournisseur,\n       MIN(prix) AS prix_min,\n       MAX(prix) AS prix_max\nFROM produits\nGROUP BY fournisseur;",
            rows: [
                { id: 1, produit: "Clavier", fournisseur: "TechPlus", prix: 45 },
                { id: 2, produit: "Souris", fournisseur: "TechPlus", prix: 22 },
                { id: 3, produit: "Écran", fournisseur: "VisionPro", prix: 320 },
                { id: 4, produit: "Câble HDMI", fournisseur: "TechPlus", prix: 8 },
                { id: 5, produit: "Webcam", fournisseur: "VisionPro", prix: 75 },
                { id: 6, produit: "Micro", fournisseur: "SoundMax", prix: 55 },
                { id: 7, produit: "Casque", fournisseur: "SoundMax", prix: 110 },
                { id: 8, produit: "Projecteur", fournisseur: "VisionPro", prix: 480 },
                { id: 9, produit: "Enceinte", fournisseur: "SoundMax", prix: 88 }
            ]
        },

        // ── Avec HAVING ──

        h1_produits_categorie: {
            tableName: "produits", groupCol: "categorie",
            aggCols: [{ fn: "COUNT", col: "*", label: "nb_produits" }],
            hint: "Table <code>produits</code> — GROUP BY categorie — HAVING COUNT(*) > 20",
            having: { label: "COUNT(*)", alias: "nb_produits", op: ">", val: 20, fn: "COUNT", col: "*" },
            sqlOverride: "SELECT categorie,\n       COUNT(*) AS nb_produits\nFROM produits\nGROUP BY categorie\nHAVING COUNT(*) > 20;",
            rows: [
                { id: 1, categorie: "Électronique", produit: "Téléphone", prix: 299 },
                { id: 2, categorie: "Électronique", produit: "Casque", prix: 89 },
                { id: 3, categorie: "Électronique", produit: "Tablette", prix: 349 },
                { id: 4, categorie: "Électronique", produit: "Écran", prix: 320 },
                { id: 5, categorie: "Électronique", produit: "Webcam", prix: 75 },
                { id: 6, categorie: "Électronique", produit: "Clavier", prix: 45 },
                { id: 7, categorie: "Électronique", produit: "Souris", prix: 22 },
                { id: 8, categorie: "Électronique", produit: "Câble HDMI", prix: 8 },
                { id: 9, categorie: "Électronique", produit: "Hub USB", prix: 18 },
                { id: 10, categorie: "Électronique", produit: "Adaptateur", prix: 12 },
                { id: 11, categorie: "Électronique", produit: "Chargeur", prix: 25 },
                { id: 12, categorie: "Électronique", produit: "Batterie", prix: 35 },
                { id: 13, categorie: "Électronique", produit: "Lampe LED", prix: 20 },
                { id: 14, categorie: "Électronique", produit: "Montre", prix: 150 },
                { id: 15, categorie: "Électronique", produit: "Enceinte", prix: 88 },
                { id: 16, categorie: "Électronique", produit: "Micro", prix: 55 },
                { id: 17, categorie: "Électronique", produit: "Projecteur", prix: 480 },
                { id: 18, categorie: "Électronique", produit: "Scanner", prix: 210 },
                { id: 19, categorie: "Électronique", produit: "Imprimante", prix: 180 },
                { id: 20, categorie: "Électronique", produit: "Disque SSD", prix: 120 },
                { id: 21, categorie: "Électronique", produit: "RAM 16 Go", prix: 65 },
                { id: 22, categorie: "Vêtements", produit: "T-shirt", prix: 25 },
                { id: 23, categorie: "Vêtements", produit: "Jean", prix: 60 },
                { id: 24, categorie: "Vêtements", produit: "Veste", prix: 90 },
                { id: 25, categorie: "Vêtements", produit: "Robe", prix: 75 },
                { id: 26, categorie: "Vêtements", produit: "Manteau", prix: 140 },
                { id: 27, categorie: "Vêtements", produit: "Pull", prix: 45 },
                { id: 28, categorie: "Vêtements", produit: "Short", prix: 30 },
                { id: 29, categorie: "Vêtements", produit: "Chemise", prix: 50 },
                { id: 30, categorie: "Vêtements", produit: "Pantalon", prix: 70 },
                { id: 31, categorie: "Vêtements", produit: "Jupe", prix: 40 },
                { id: 32, categorie: "Vêtements", produit: "Blouson", prix: 120 },
                { id: 33, categorie: "Vêtements", produit: "Ceinture", prix: 20 },
                { id: 34, categorie: "Vêtements", produit: "Chaussettes", prix: 8 },
                { id: 35, categorie: "Vêtements", produit: "Écharpe", prix: 22 },
                { id: 36, categorie: "Vêtements", produit: "Bonnet", prix: 15 },
                { id: 37, categorie: "Vêtements", produit: "Gants", prix: 18 },
                { id: 38, categorie: "Vêtements", produit: "Chapeau", prix: 35 },
                { id: 39, categorie: "Vêtements", produit: "Sous-vêtements", prix: 12 },
                { id: 40, categorie: "Vêtements", produit: "Pyjama", prix: 28 },
                { id: 41, categorie: "Vêtements", produit: "Legging", prix: 25 },
                { id: 42, categorie: "Vêtements", produit: "Débardeur", prix: 15 },
                { id: 43, categorie: "Livres", produit: "Roman", prix: 12 },
                { id: 44, categorie: "Livres", produit: "BD", prix: 18 },
                { id: 45, categorie: "Livres", produit: "Manga", prix: 8 },
                { id: 46, categorie: "Livres", produit: "Cuisine", prix: 25 },
                { id: 47, categorie: "Livres", produit: "Histoire", prix: 22 },
                { id: 48, categorie: "Livres", produit: "Sciences", prix: 30 },
                { id: 49, categorie: "Livres", produit: "Policier", prix: 14 },
                { id: 50, categorie: "Livres", produit: "Fantaisie", prix: 16 },
                { id: 51, categorie: "Livres", produit: "SF", prix: 15 },
                { id: 52, categorie: "Livres", produit: "Biographie", prix: 24 },
                { id: 53, categorie: "Livres", produit: "Voyage", prix: 28 },
                { id: 54, categorie: "Livres", produit: "Jeunesse", prix: 10 },
                { id: 55, categorie: "Sport", produit: "Ballon", prix: 30 },
                { id: 56, categorie: "Sport", produit: "Raquette", prix: 45 },
                { id: 57, categorie: "Sport", produit: "Vélo", prix: 350 },
                { id: 58, categorie: "Sport", produit: "Haltères", prix: 60 },
                { id: 59, categorie: "Sport", produit: "Tapis yoga", prix: 25 }
            ]
        },

        h2_clients_ville: {
            tableName: "clients", groupCol: "ville",
            aggCols: [{ fn: "COUNT", col: "*", label: "nb_clients" }],
            hint: "Table <code>clients</code> — GROUP BY ville — HAVING COUNT(*) > 5 — ORDER BY nb_clients DESC",
            having: { label: "COUNT(*)", alias: "nb_clients", op: ">", val: 5, fn: "COUNT", col: "*" },
            orderBy: { col: "nb_clients", dir: "DESC" },
            sqlOverride: "SELECT ville,\n       COUNT(*) AS nb_clients\nFROM clients\nGROUP BY ville\nHAVING COUNT(*) > 5\nORDER BY nb_clients DESC;",
            rows: [
                { id: 1, nom: "Alice", ville: "Paris", age: 28 },
                { id: 2, nom: "Bob", ville: "Lyon", age: 34 },
                { id: 3, nom: "Claire", ville: "Paris", age: 22 },
                { id: 4, nom: "David", ville: "Marseille", age: 41 },
                { id: 5, nom: "Emma", ville: "Lyon", age: 29 },
                { id: 6, nom: "Farid", ville: "Paris", age: 36 },
                { id: 7, nom: "Gaëlle", ville: "Marseille", age: 25 },
                { id: 8, nom: "Hugo", ville: "Lyon", age: 31 },
                { id: 9, nom: "Inès", ville: "Paris", age: 27 },
                { id: 10, nom: "Jules", ville: "Paris", age: 45 },
                { id: 11, nom: "Karim", ville: "Lyon", age: 38 },
                { id: 12, nom: "Léa", ville: "Paris", age: 32 },
                { id: 13, nom: "Marc", ville: "Bordeaux", age: 29 },
                { id: 14, nom: "Nina", ville: "Paris", age: 24 },
                { id: 15, nom: "Oscar", ville: "Lyon", age: 41 },
                { id: 16, nom: "Paula", ville: "Bordeaux", age: 35 },
                { id: 17, nom: "Quentin", ville: "Paris", age: 30 },
                { id: 18, nom: "Rosa", ville: "Bordeaux", age: 26 },
                { id: 19, nom: "Sam", ville: "Lyon", age: 33 },
                { id: 20, nom: "Tina", ville: "Marseille", age: 28 }
            ]
        },

        h3_ventes_mensuelles: {
            tableName: "ventes_mensuelles", groupCol: "mois",
            aggCols: [{ fn: "SUM", col: "ventes", label: "chiffre_affaires" }],
            hint: "Table <code>ventes_mensuelles</code> — GROUP BY mois — HAVING SUM(ventes) > 50000",
            having: { label: "SUM(ventes)", alias: "chiffre_affaires", op: ">", val: 50000, fn: "SUM", col: "ventes" },
            orderBy: { col: "chiffre_affaires", dir: "DESC" },
            sqlOverride: "SELECT mois,\n       SUM(ventes) AS chiffre_affaires\nFROM ventes_mensuelles\nGROUP BY mois\nHAVING SUM(ventes) > 50000\nORDER BY chiffre_affaires DESC;",
            rows: [
                { id: 1, mois: "Janvier", region: "Nord", ventes: 18000 },
                { id: 2, mois: "Janvier", region: "Sud", ventes: 22000 },
                { id: 3, mois: "Janvier", region: "Est", ventes: 15000 },
                { id: 4, mois: "Février", region: "Nord", ventes: 12000 },
                { id: 5, mois: "Février", region: "Sud", ventes: 14000 },
                { id: 6, mois: "Février", region: "Est", ventes: 11000 },
                { id: 7, mois: "Mars", region: "Nord", ventes: 25000 },
                { id: 8, mois: "Mars", region: "Sud", ventes: 28000 },
                { id: 9, mois: "Mars", region: "Est", ventes: 19000 },
                { id: 10, mois: "Avril", region: "Nord", ventes: 30000 },
                { id: 11, mois: "Avril", region: "Sud", ventes: 35000 },
                { id: 12, mois: "Avril", region: "Est", ventes: 27000 },
                { id: 13, mois: "Mai", region: "Nord", ventes: 40000 },
                { id: 14, mois: "Mai", region: "Sud", ventes: 45000 },
                { id: 15, mois: "Mai", region: "Est", ventes: 32000 },
                { id: 16, mois: "Juin", region: "Nord", ventes: 55000 },
                { id: 17, mois: "Juin", region: "Sud", ventes: 60000 },
                { id: 18, mois: "Juin", region: "Est", ventes: 48000 }
            ]
        },

        h4_clients_region: {
            tableName: "clients", groupCol: "region",
            aggCols: [{ fn: "AVG", col: "age", label: "age_moyen" }],
            hint: "Table <code>clients</code> — GROUP BY region — HAVING AVG(age) > 40",
            having: { label: "AVG(age)", alias: "age_moyen", op: ">", val: 40, fn: "AVG", col: "age" },
            orderBy: { col: "age_moyen", dir: "DESC" },
            sqlOverride: "SELECT region,\n       AVG(age) AS age_moyen\nFROM clients\nGROUP BY region\nHAVING AVG(age) > 40\nORDER BY age_moyen DESC;",
            rows: [
                { id: 1, nom: "Alice", region: "Nord", age: 52 },
                { id: 2, nom: "Bob", region: "Sud", age: 34 },
                { id: 3, nom: "Claire", region: "Nord", age: 47 },
                { id: 4, nom: "David", region: "Est", age: 38 },
                { id: 5, nom: "Emma", region: "Sud", age: 29 },
                { id: 6, nom: "Farid", region: "Ouest", age: 61 },
                { id: 7, nom: "Gaëlle", region: "Nord", age: 55 },
                { id: 8, nom: "Hugo", region: "Est", age: 42 },
                { id: 9, nom: "Inès", region: "Sud", age: 27 },
                { id: 10, nom: "Jules", region: "Ouest", age: 58 },
                { id: 11, nom: "Karim", region: "Est", age: 36 },
                { id: 12, nom: "Léa", region: "Nord", age: 44 },
                { id: 13, nom: "Marc", region: "Ouest", age: 63 },
                { id: 14, nom: "Nina", region: "Sud", age: 31 },
                { id: 15, nom: "Oscar", region: "Est", age: 39 }
            ]
        },

        h5_produits_fournisseur: {
            tableName: "produits", groupCol: "fournisseur",
            aggCols: [{ fn: "MIN", col: "prix_unitaire", label: "prix_min" }],
            hint: "Table <code>produits</code> — GROUP BY fournisseur — HAVING MIN(prix_unitaire) &lt; 10",
            having: { label: "MIN(prix_unitaire)", alias: "prix_min", op: "<", val: 10, fn: "MIN", col: "prix_unitaire" },
            orderBy: { col: "prix_min", dir: "ASC" },
            sqlOverride: "SELECT fournisseur,\n       MIN(prix_unitaire) AS prix_min\nFROM produits\nGROUP BY fournisseur\nHAVING MIN(prix_unitaire) < 10\nORDER BY prix_min ASC;",
            rows: [
                { id: 1, produit: "Câble USB", fournisseur: "TechPlus", prix_unitaire: 4.5 },
                { id: 2, produit: "Clavier", fournisseur: "TechPlus", prix_unitaire: 45 },
                { id: 3, produit: "Souris", fournisseur: "TechPlus", prix_unitaire: 22 },
                { id: 4, produit: "Vis M3", fournisseur: "FixPro", prix_unitaire: 0.10 },
                { id: 5, produit: "Écrou M3", fournisseur: "FixPro", prix_unitaire: 0.08 },
                { id: 6, produit: "Rondelle", fournisseur: "FixPro", prix_unitaire: 0.05 },
                { id: 7, produit: "Cheville", fournisseur: "FixPro", prix_unitaire: 0.20 },
                { id: 8, produit: "Écran", fournisseur: "VisionPro", prix_unitaire: 320 },
                { id: 9, produit: "Webcam", fournisseur: "VisionPro", prix_unitaire: 75 },
                { id: 10, produit: "Projecteur", fournisseur: "VisionPro", prix_unitaire: 480 },
                { id: 11, produit: "Micro", fournisseur: "SoundMax", prix_unitaire: 55 },
                { id: 12, produit: "Casque", fournisseur: "SoundMax", prix_unitaire: 110 },
                { id: 13, produit: "Pile AA", fournisseur: "PowerCell", prix_unitaire: 1.20 },
                { id: 14, produit: "Pile AAA", fournisseur: "PowerCell", prix_unitaire: 0.90 },
                { id: 15, produit: "Batterie 9V", fournisseur: "PowerCell", prix_unitaire: 3.50 }
            ]
        }
    };

    const COLORS = [
        { bg: "#eff6ff", border: "#3b82f6" },
        { bg: "#ecfdf5", border: "#10b981" },
        { bg: "#fffbeb", border: "#f59e0b" },
        { bg: "#fef2f2", border: "#ef4444" },
        { bg: "#f5f3ff", border: "#8b5cf6" },
        { bg: "#fdf2f8", border: "#ec4899" }
    ];

    const datasetEl = document.getElementById("gbDataset");
    const aggFnEl = document.getElementById("gbAggFn");
    const aggFnField = document.getElementById("gbAggFnField");
    const sourceWrap = document.getElementById("gbSourceWrap");
    const groupsGrid = document.getElementById("gbGroupsGrid");
    const havingGrid = document.getElementById("gbHavingGrid");
    const resultWrap = document.getElementById("gbResultWrap");
    const resultMeta = document.getElementById("gbResultMeta");
    const gbDatasetHint = document.getElementById("gbDatasetHint");
    const toggleStep1 = document.getElementById("toggleStep1");
    const toggleStep2 = document.getElementById("toggleStep2");
    const toggleStep2b = document.getElementById("toggleStep2b");
    const toggleStep3 = document.getElementById("toggleStep3");
    const step1 = document.getElementById("gbStep1");
    const step2 = document.getElementById("gbStep2");
    const step2b = document.getElementById("gbStep2b");
    const step3 = document.getElementById("gbStep3");
    const arrow1 = document.getElementById("gbArrow1");
    const arrow2b = document.getElementById("gbArrow2b");
    const arrow3 = document.getElementById("gbArrow3");
    const orderNote = document.getElementById("gbOrderNote");

    function escapeHtml(v) {
        return String(v ?? "")
            .replace(/&/g, "&amp;").replace(/</g, "&lt;")
            .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }

    function getColumns(rows) {
        const cols = new Set();
        rows.forEach(r => Object.keys(r).forEach(k => cols.add(k)));
        return [...cols];
    }

    function groupRows(rows, groupCol) {
        const map = new Map();
        rows.forEach(row => {
            const key = row[groupCol];
            if (!map.has(key)) map.set(key, []);
            map.get(key).push(row);
        });
        return map;
    }

    function applyAggCols(gRows, aggCols, freeAggFn) {
        return aggCols.map(a => {
            const fn = a.fn === "FREE" ? freeAggFn : a.fn;
            if (fn === "COUNT") return { label: a.label, val: gRows.length };
            if (fn === "SUM_EXPR") return { label: a.label, val: gRows.reduce((s, r) => s + a.expr(r), 0) };
            const vals = gRows.map(r => Number(r[a.col] ?? 0));
            let val;
            switch (fn) {
                case "SUM": val = vals.reduce((s, v) => s + v, 0); break;
                case "AVG": val = parseFloat((vals.reduce((s, v) => s + v, 0) / vals.length).toFixed(2)); break;
                case "MIN": val = Math.min(...vals); break;
                case "MAX": val = Math.max(...vals); break;
            }
            return { label: a.label, val };
        });
    }

    function evalHaving(aggVal, having) {
        switch (having.op) {
            case ">": return aggVal > having.val;
            case ">=": return aggVal >= having.val;
            case "<": return aggVal < having.val;
            case "<=": return aggVal <= having.val;
            case "=": return aggVal === having.val;
        }
        return true;
    }

    // Retourne le libellé à afficher dans la condition HAVING :
    // l'alias s'il est défini, sinon l'expression brute
    function havingDisplayLabel(having) {
        return having.alias || having.label;
    }

    function buildLegendHtml(keys) {
        const dots = keys.map((k, i) => {
            const c = COLORS[i % COLORS.length];
            return `<span><i class="gb-dot" style="background:${c.bg};border-color:${c.border};"></i>${escapeHtml(String(k))}</span>`;
        }).join("");
        return `<span class="gb-legend-title">Groupes :</span>${dots}`;
    }

    function buildSql(data, freeAggFn) {
        if (data.sqlOverride) return data.sqlOverride;
        const a = data.aggCols[0];
        const fn = a.fn === "FREE" ? freeAggFn : a.fn;
        const colExpr = fn === "COUNT" ? "*" : a.col;
        return `SELECT ${data.groupCol},\n       ${fn}(${colExpr}) AS ${a.label}\nFROM ${data.tableName}\nGROUP BY ${data.groupCol};`;
    }

    function renderSource(rows, groupCol, keys, data) {
        const cols = getColumns(rows);
        const showExprCol = data.aggCols.some(a => a.fn === "SUM_EXPR");

        let html = "<table><thead><tr>"
            + cols.map(c => `<th class="${c === groupCol ? "gb-col-group" : ""}">${escapeHtml(c)}</th>`).join("")
            + (showExprCol ? `<th>prix × quantite</th>` : "")
            + "</tr></thead><tbody>";

        rows.forEach(row => {
            const ci = keys.indexOf(row[groupCol]) % COLORS.length;
            html += `<tr class="gb-src-row-${ci}">`
                + cols.map(c => `<td class="${c === groupCol ? "gb-col-group" : ""}">${escapeHtml(row[c] ?? "NULL")}</td>`).join("");
            if (showExprCol) {
                const expr = data.aggCols.find(a => a.fn === "SUM_EXPR");
                html += `<td><strong>${expr.expr(row)}</strong></td>`;
            }
            html += "</tr>";
        });

        sourceWrap.innerHTML = html + "</tbody></table>";
    }

    function renderGroups(rows, groupCol, keys, grouped, data, freeAggFn) {
        // ── Responsive : auto-fill, min 220px ──
        groupsGrid.style.gridTemplateColumns = "";
        const cols = getColumns(rows);
        const showExprCol = data.aggCols.some(a => a.fn === "SUM_EXPR");

        let html = "";
        keys.forEach((key, i) => {
            const gRows = grouped.get(key);
            const ci = i % COLORS.length;
            const aggs = applyAggCols(gRows, data.aggCols, freeAggFn);

            const tableHtml = "<table><thead><tr>"
                + cols.map(col => `<th>${escapeHtml(col)}</th>`).join("")
                + (showExprCol ? `<th>prix × quantite</th>` : "")
                + "</tr></thead><tbody>"
                + gRows.map(row => {
                    let tr = "<tr>" + cols.map(col => `<td>${escapeHtml(row[col] ?? "NULL")}</td>`).join("");
                    if (showExprCol) {
                        const expr = data.aggCols.find(a => a.fn === "SUM_EXPR");
                        tr += `<td><strong>${expr.expr(row)}</strong></td>`;
                    }
                    return tr + "</tr>";
                }).join("")
                + "</tbody></table>";

            const badgesHtml = aggs.map(a =>
                `<span class="gb-agg-badge">
                    <span class="gb-agg-fn">${escapeHtml(a.label)}</span> = <strong>${a.val}</strong>
                </span>`
            ).join("");

            html += `
            <div class="gb-group-block gb-color-${ci}">
                <div class="gb-group-header">
                    <span>📦 <strong>${escapeHtml(String(key))}</strong></span>
                    <span class="gb-group-count">${gRows.length} ligne(s)</span>
                </div>
                <div class="gb-group-rows">
                    ${tableHtml}
                    <div class="gb-agg-badges">${badgesHtml}</div>
                </div>
            </div>`;
        });

        groupsGrid.innerHTML = html;
    }

    function renderHaving(rows, groupCol, keys, grouped, data, freeAggFn) {
        const having = data.having;
        // ── Responsive : auto-fill, min 220px ──
        havingGrid.style.gridTemplateColumns = "";
        const dispLabel = havingDisplayLabel(having);

        document.getElementById("gbHavingSummary").innerHTML =
            `🔎 Condition HAVING : <strong>${escapeHtml(dispLabel)} ${escapeHtml(having.op)} ${having.val}</strong>
             — seuls les groupes qui satisfont cette condition sont conservés.`;

        let html = "";
        keys.forEach((key, i) => {
            const gRows = grouped.get(key);
            const ci = i % COLORS.length;
            const aggs = applyAggCols(gRows, data.aggCols, freeAggFn);
            const aggVal = aggs[0].val;
            const kept = evalHaving(aggVal, having);

            const badgesHtml = aggs.map(a =>
                `<span class="gb-agg-badge">
                    <span class="gb-agg-fn">${escapeHtml(a.label)}</span> = <strong>${a.val}</strong>
                </span>`
            ).join("");

            // ── Condition affichée avec alias si disponible ──
            const conditionHtml = `
                <span class="gb-having-condition">
                    ${escapeHtml(dispLabel)} ${escapeHtml(having.op)} ${having.val} ?
                    <strong>${kept ? "✅ OUI" : "❌ NON"}</strong>
                </span>`;

            const tagHtml = kept
                ? `<span class="gb-kept-tag">✅ Conservé</span>`
                : `<span class="gb-filtered-tag">❌ Éliminé</span>`;

            html += `
            <div class="gb-group-block gb-color-${ci}${kept ? "" : " gb-filtered"}">
                <div class="gb-group-header">
                    <span>📦 <strong>${escapeHtml(String(key))}</strong></span>
                    <span class="gb-group-count">${gRows.length} ligne(s)</span>
                </div>
                <div class="gb-group-rows">
                    <div class="gb-agg-badges">
                        ${badgesHtml}
                        ${conditionHtml}
                    </div>
                    <div>${tagHtml}</div>
                </div>
            </div>`;
        });

        havingGrid.innerHTML = html;
    }

    function renderResult(grouped, keys, groupCol, data, freeAggFn, totalRows) {
        const having = data.having || null;
        const orderBy = data.orderBy || null;

        let filtKeys = having
            ? keys.filter(key => {
                const aggs = applyAggCols(grouped.get(key), data.aggCols, freeAggFn);
                return evalHaving(aggs[0].val, having);
            })
            : [...keys];

        if (orderBy) {
            filtKeys.sort((a, b) => {
                const vA = applyAggCols(grouped.get(a), data.aggCols, freeAggFn)[0].val;
                const vB = applyAggCols(grouped.get(b), data.aggCols, freeAggFn)[0].val;
                return orderBy.dir === "DESC" ? vB - vA : vA - vB;
            });
        }

        if (orderBy) {
            orderNote.classList.remove("gb-hidden");
            orderNote.textContent = `↕ ORDER BY ${orderBy.col} ${orderBy.dir} — lignes triées par valeur ${orderBy.dir === "DESC" ? "décroissante" : "croissante"}.`;
        } else {
            orderNote.classList.add("gb-hidden");
        }

        let html = "<table><thead><tr>"
            + `<th class="gb-col-group">${escapeHtml(groupCol)}</th>`
            + data.aggCols.map(a => `<th>${escapeHtml(a.label)}</th>`).join("")
            + "</tr></thead><tbody>";

        filtKeys.forEach(key => {
            const origIdx = keys.indexOf(key);
            const aggs = applyAggCols(grouped.get(key), data.aggCols, freeAggFn);
            html += `<tr class="gb-res-row-${origIdx % COLORS.length}">
                <td class="gb-col-group">${escapeHtml(String(key))}</td>
                ${aggs.map(a => `<td><strong>${a.val}</strong></td>`).join("")}
            </tr>`;
        });

        html += "</tbody></table>";
        resultWrap.innerHTML = html;

        const filtNote = having ? ` (${keys.length - filtKeys.length} groupe(s) éliminé(s) par HAVING)` : "";
        const sortNote = orderBy ? `, triées par ${orderBy.col} ${orderBy.dir}` : "";
        resultMeta.textContent = `${totalRows} ligne(s) source → ${keys.length} groupe(s)${filtNote} → ${filtKeys.length} ligne(s) résultante(s)${sortNote}.`;

        document.getElementById("gbStep3HavingNote").textContent = having
            ? "ayant passé le filtre HAVING" : "";
    }

    function updateVisibility(hasHaving) {
        const s1 = toggleStep1.checked;
        const s2 = toggleStep2.checked;
        const s2b = toggleStep2b.checked && hasHaving;
        const s3 = toggleStep3.checked;

        step1.classList.toggle("gb-hidden", !s1);
        step2.classList.toggle("gb-hidden", !s2);
        step2b.classList.toggle("gb-hidden", !s2b);
        step3.classList.toggle("gb-hidden", !s3);

        arrow1.classList.toggle("gb-hidden", !s1 || !s2);
        arrow2b.classList.toggle("gb-hidden", !s2 || !s2b);
        arrow3.classList.toggle("gb-hidden", !(s2b ? s2b : s2) || !s3);

        toggleStep2b.disabled = !hasHaving;
        toggleStep2b.parentElement.style.opacity = hasHaving ? "1" : "0.4";
    }

    function renderAll() {
        const data = datasets[datasetEl.value];
        const freeAggFn = aggFnEl.value;
        const { rows, groupCol, hint } = data;
        const hasHaving = !!data.having;

        aggFnField.classList.toggle("gb-hidden", data.aggCols.every(a => a.fn !== "FREE"));

        const grouped = groupRows(rows, groupCol);
        const keys = [...grouped.keys()];
        const sql = buildSql(data, freeAggFn);

        gbDatasetHint.innerHTML = hint;
        document.getElementById("gbSqlStep1").textContent = sql;
        document.getElementById("gbSqlStep3").textContent = sql;

        const legendHtml = buildLegendHtml(keys);
        document.getElementById("gbLegend1").innerHTML = legendHtml;
        document.getElementById("gbLegend2").innerHTML = legendHtml;
        document.getElementById("gbLegend3").innerHTML = legendHtml;

        renderSource(rows, groupCol, keys, data);
        renderGroups(rows, groupCol, keys, grouped, data, freeAggFn);
        if (hasHaving) renderHaving(rows, groupCol, keys, grouped, data, freeAggFn);
        renderResult(grouped, keys, groupCol, data, freeAggFn, rows.length);

        updateVisibility(hasHaving);
    }

    [toggleStep1, toggleStep2, toggleStep2b, toggleStep3]
        .forEach(el => el.addEventListener("change", () => updateVisibility(!!datasets[datasetEl.value].having)));
    datasetEl.addEventListener("change", renderAll);
    aggFnEl.addEventListener("change", renderAll);
    document.getElementById("gbReloadBtn").addEventListener("click", renderAll);

    document.getElementById("gbShareBtn").addEventListener("click", () => {
        const url = window.location.href;
        if (navigator.share) {
            navigator.share({ title: "Visualiseur GROUP BY SQL", url }).catch(() => { });
        } else {
            navigator.clipboard.writeText(url).then(() => {
                const toast = document.getElementById("gbShareToast");
                toast.style.display = "block";
                setTimeout(() => { toast.style.display = "none"; }, 2500);
            }).catch(() => { prompt("Copiez ce lien :", url); });
        }
    });

    renderAll();
})()